<template>
    <section id="contact" class="contact-area dark-bg ptb_100">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-12">
                    <!-- Section Heading -->
                    <div class="section-heading text-center mb-3">
                        <h2 class="special-heading text-white">Kontaktirajte nas</h2>
                    </div>
                    <!-- Contact Us -->
                    <div class="contact-us">
                        <div class="phone-nums">
                            <!-- Contact Info -->
                            <div class="contact-info color-1 bg-hover active hover-bottom dark-shadow text-center p-5 m-3">
                                <span><i class="fas fa-mobile-alt fa-3x"></i></span>
                                <a class="d-block my-2" href="tel:+381 (0) 65 3400 331">
                                    <h3 class="text-white">+381 (0) 65 3400 331</h3>
                                </a>
                            </div>
                            <!-- Contact Info -->
                            <div class="contact-info color-1 bg-hover active hover-bottom dark-shadow text-center p-5 m-3">
                                <span><i class="fas fa-mobile-alt fa-3x"></i></span>
                                <a class="d-block my-2" href="tel:+381 (0) 60 4400 847">
                                    <h3 class="text-white">+381 (0) 60 4400 847</h3>
                                </a>
                            </div>
                        </div>
                        
                        <div class="email contact-info color-3 bg-hover active hover-bottom dark-shadow text-center p-5 m-3">
                          <!-- Contact Info -->
                          <span><i class="fas fa-envelope-open-text fa-3x"></i></span>
                          <a class="d-none d-sm-block my-2" href="mailto:office@vmpartners.rs">
                            <h3 class="text-white">office@vmpartners.rs</h3>
                          </a>
                          <a class="d-block d-sm-none my-2" href="mailto:office@vmpartners.rs">
                            <h3 class="text-white">office@vmpartners.rs</h3>
                          </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>
 .special-heading {
   margin-bottom: 20px;
 }

 @media(min-width: 768px) {
   .phone-nums {
     display: flex;
     flex-direction: row;
     justify-content: space-around;
   }
 }

 .email {
   max-width: 400px;
   margin: auto!important;
 }
</style>
